import { createIcon } from '../createIcon.tsx';

export const TreeIcon = createIcon(
	'TreeIcon',
	<>
		<path d="M12 2 7 9h3v4H6l6 8 6-8h-4V9h3z" />
		<line x1="12" y1="21" x2="12" y2="22" />
	</>,
);
